import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { flowNodeDetail, auditDetail, whiteList, addWhite } from './request';
export default {
  props: ['id'],
  data() {
    return {
      infoObj: {},
      whiteList: [],
      data: [],
      columns: [{
        slots: {
          title: '节点'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '节点名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '白名单'
        },
        dataIndex: 'whitelist',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'white'
        }
      }]
    };
  },
  created() {
    setTimeout(() => {
      this.getDataFun();
    }, 400);
  },
  methods: {
    async getDataFun() {
      this.infoObj = await auditDetail({
        auditFlowId: this.id
      });
      this.whiteList = await whiteList({
        auditFlowId: this.id
      });
      this.data = await flowNodeDetail({
        auditFlowId: this.id,
        customerId: this.infoObj.customerId
      });
    },
    async onSubmit() {
      let arr = [];
      this.data.map(item => {
        arr.push({
          flowNodeId: item.id,
          whiteList: item.whitelist.join(',')
        });
      });
      console.log(arr);
      // if()
      await addWhite({
        auditFlowId: this.id,
        customerId: this.infoObj.customerId,
        whiteList: JSON.stringify(arr)
      });
      this.$message.success(this.$t('操作成功') + '!');
      this.$router.push('/examine/auditManage');
    }
  }
};